var style = {"z-qty-loader":"z-qty-loader","z-qty-loader--small":"z-qty-loader--small"};

export { style as default };
//# sourceMappingURL=QuantityLoader.module.scss.js.map
